/**
 * Created by anthony on 6/21/14.
 */
/**
 * Created by anthony on 6/21/14.
 */
var familyThreshEditSums = angular.module('familyThreshEditSums', ['editSums', 'familyThresholds']);
familyThreshEditSums.service('FamilyThreshEditSumsService', function(ApplicationService, RestService, EditSumsService,
                                                                     FamilyThresholdsService, $q){
    return {
        putHelper: function (dataThresh, dataEditSums, putDataThresh, putDataEditSums)
        {
            putDataThresh.familyID = dataThresh.familyID;
            putDataThresh.applicationID = dataEditSums.applicationID;
            putDataEditSums.familyID = dataEditSums.familyID;
            putDataEditSums.applicationID = dataEditSums.applicationID;
            return $q.all([
                EditSumsService.put(putDataEditSums),
                FamilyThresholdsService.put(putDataThresh)
            ]);
        }
    }
});